/** 2-decimal-place number formatting shared by every Summary 2 table. */
export const formatNumber = (value: number): string =>
  new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
